import { IsStringEmpty } from './GlobalFunctions'

const STRING_BOOLEAN_YES: string = 'yes'
const STRING_BOOLEAN_ON: string = 'on'
const STRING_BOOLEAN_TRUE: string = 'true'
const STRING_BOOLEAN_ONE: string = '1'

/**
 * Converts a licence value to a boolean
 *
 * @param licenceBoolean - The licence value to convert
 */
export const convertLicenceBooleanToBoolean = (licenceBoolean?: string): boolean => {
    if (IsStringEmpty(licenceBoolean)) {
        return false
    }

    const lowerCaseLicenceBoolean: string = licenceBoolean.toLowerCase()

    return (
        lowerCaseLicenceBoolean === STRING_BOOLEAN_YES ||
        lowerCaseLicenceBoolean === STRING_BOOLEAN_ON ||
        lowerCaseLicenceBoolean === STRING_BOOLEAN_TRUE ||
        lowerCaseLicenceBoolean === STRING_BOOLEAN_ONE
    )
}
